var imageDataUrl;
var imageHeight;
var imageWidth;
var token;
var tokenTtlSeconds;

$.ajax({
    type: 'POST',
    url: captcha_challenge_baseurl + "/captchachallengecreation",
    headers: {
        "Content-Type": "application/vnd.captcha.challenge.parameter-v1+json",
        "Accept": "application/vnd.captcha.challenge-v1+json"
    },
    data: JSON.stringify({ 'siteKey': siteKey }),
    success: function (response) {
        imageDataUrl = response.imageDataUrl;
        imageHeight = response.imageHeight;
        imageWidth = response.imageWidth;
        token = response.token;
        tokenTtlSeconds = response.tokenTtlSeconds;
        $('.captcha-image').append('<img id="contact-captcha-image" src="'+imageDataUrl+'" width="'+imageWidth+'" height="'+imageHeight+'"/>');
        $(' #form_token').val(token);
    },
    error: function (response) {
    }
});

$("#contact-captcha-refresh").on("click", function() {
    $('#contact-captcha').addClass("loading");
    $.ajax({
        type: 'POST',
        url: captcha_challenge_baseurl + "/captchachallengecreation",
        headers: {
            "Content-Type": "application/vnd.captcha.challenge.parameter-v1+json",
            "Accept": "application/vnd.captcha.challenge-v1+json"
        },
        data: JSON.stringify({ 'siteKey': siteKey }),
        success: function (response) {
            imageDataUrl = response.imageDataUrl;
            imageHeight = response.imageHeight;
            imageWidth = response.imageWidth;
            token = response.token;
            tokenTtlSeconds = response.tokenTtlSeconds;
            $('#contact-captcha-image').attr({ 'src': imageDataUrl, 'width':imageWidth, 'height':imageHeight });
            $('#form_token').val(token);
            $('#contact-captcha').removeClass("loading");
        },
        error: function (response) {
            $('#contact-captcha').removeClass("loading");
        }
    });
});

